import { AppStack } from 'component/navigation/app-stack';
import { ScreenErrorBoundary } from 'component/navigation/screen-error-boundary';

export const unstable_settings = {
    screenErrorBoundary: ScreenErrorBoundary,
};

export default function AuthLayout() {
    return <AppStack />;
}
